import React, { useContext, useState } from 'react';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UserTable from './Curators';
import CreateCurators from './CreateCurators';
import InviteUsers from '../UserManagement/InviteUsers';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import PeopleIcon from '@mui/icons-material/People';
import { styleBg } from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function UserList() {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [meta, setMeta] = useState({ total: 0 });

  const handleDescription = () => {
    if (value === 0) {
      return "Total Museum Chiefs"
    } else if (value === 1) {
      return "Total Curator"
    } else if (value === 2) {
      return "Total Museum Assistant"
    } else if (value === 3) {
      return "Total Conservators"
    } else if (value === 4) {
      return "Total Interns"
    } else if (value === 5) {
      return "Total Volunteers"
    } else {
      return "Total Receptionists"
    }
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageWrapper>
      <Box>
        <DashboardHeader total={meta?.total} IconName={PeopleIcon} iconColor={'#ff9653'} desc={handleDescription()} title={'User Lists'} handleOpen={handleOpen}
          btnName={'+ Invite Users'}
        />
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mt:3 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            '& .MuiTabs-scrollable': {
              overflowX: 'auto !important',
            },
            '& .MuiTab-root': {
              minWidth: '150px !important',
              maxWidth: '210px !important',
              flexShrink: 0,
            },
          }}
        >
          <Tab label="MUSEUM CHIEFS" {...a11yProps(0)} sx={{ ...styleBg(0, value) }} />
          <Tab label="CURATORS" {...a11yProps(1)} sx={{ ...styleBg(1, value) }} />
          <Tab label="MUSEUM ASSISTANTS" {...a11yProps(2)} sx={{ ...styleBg(2, value) }} />
          <Tab label="CONSERVATORS" {...a11yProps(3)} sx={{ ...styleBg(3, value) }} />
          <Tab label="INTERNS" {...a11yProps(4)} sx={{ ...styleBg(4, value) }} />
          <Tab label="VOLUNTEERS" {...a11yProps(5)} sx={{ ...styleBg(5, value) }} />
          <Tab label="RECEPTIONISTS" {...a11yProps(6)} sx={{ ...styleBg(6, value) }} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <UserTable roleId={10} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UserTable roleId={2} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <UserTable roleId={3} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <UserTable roleId={7} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <UserTable roleId={5} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <UserTable roleId={6} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <UserTable roleId={4} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      {open &&
        <CreateCurators open={open} handleAction={handleClose} />
      }
    </PageWrapper>
  );
}